// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1Jkw5","head":"Table_head__3GgZ2","col":"Table_col__2Eds0"};